import { styled, TimePicker } from '../../base-components';

export const StyledTimePicker = styled(TimePicker)(({ theme }) => {
    return {
        width: '100%',
        '& .MuiInputBase-root': {
            borderRadius: '15px',
        },
        '& .MuiIconButton-root': {
            width: '32px',
            height: '32px',
        },
        '& .MuiFormHelperText-root': {
            position: 'absolute',
            top: '100%',
            marginTop: '0px',
            marginInlineStart: theme.spacing(1),
        },
    };
});
